import { Col, Form, Input, Row, Select } from 'antd';
import React, { useCallback, useEffect, useState } from 'react';
import { instanceRef } from '../../utils/axios';

const { Option } = Select;

const VehiculoCartaVerdeForm = ({ data, updateData, form }) => {
  const [marcas, setMarcas] = useState([]);
  const [modelos, setModelos] = useState([]);
  const [submodelos, setSubmodelos] = useState([]);
  const [anios, setAnios] = useState([]);

  const getMarcas = useCallback(async () => {
    try {
      const response = await instanceRef.instance.get(`data/marcas`);
      const orderedMarcas = response.data.data.sort(function test(a, b) {
        if (a.descripcion < b.descripcion) {
          return -1;
        }
        if (a.descripcion > b.descripcion) {
          return 1;
        }
        return 0;
      });
      setMarcas(orderedMarcas);
    } catch (error) {
      // error
    }
  }, []);

  const getModelos = useCallback(async () => {
    try {
      const response = await instanceRef.instance.get(
        `data/modelos?marca=${data.marca}`
      );
      const orderedModelos = response.data.data
        ? response.data.data.sort(function test(a, b) {
            if (a.descripcion < b.descripcion) {
              return -1;
            }
            if (a.descripcion > b.descripcion) {
              return 1;
            }
            return 0;
          })
        : [];
      setModelos(orderedModelos);
    } catch (error) {
      // error
    }
  }, [data.marca]);

  const getSubmodelos = useCallback(async () => {
    try {
      const response = await instanceRef.instance.get(
        `data/submodelos?marca=${data.marca}&modelo=${data.modelo}&anio=${data.anio}`
      );
      const orderedSubmodelos = response.data.data
        ? response.data.data.sort(function test(a, b) {
            if (a.descripcion < b.descripcion) {
              return -1;
            }
            if (a.descripcion > b.descripcion) {
              return 1;
            }
            return 0;
          })
        : [];
      setSubmodelos(orderedSubmodelos);
    } catch (error) {
      // error
    }
  }, [data.marca, data.modelo, data.anio]);

  const getAnios = useCallback(async () => {
    try {
      const response = await instanceRef.instance.get(
        `data/anios?marca=${data.marca}&modelo=${data.modelo}`
      );
      setAnios(response.data.data);
    } catch (error) {
      // error
    }
  }, [data.marca, data.modelo]);

  useEffect(() => {
    if (data.marca) {
      getModelos();
    }
  }, [data.marca, getModelos]);

  useEffect(() => {
    if (data.modelo) {
      getAnios();
    }
  }, [data.modelo, getAnios]);

  useEffect(() => {
    if (data.anio) {
      getSubmodelos();
    }
  }, [data.anio, getSubmodelos]);

  const getDescriptions = useCallback(() => {
    const marcaDescripcion =
      marcas.find((item) => item.id === data.marca)?.descripcion || null;
    const modeloDescripcion =
      modelos.find((item) => item.id === data.modelo)?.descripcion || null;
    const submodeloDescripcion =
      submodelos.find((item) => item.id === data.submodelo)?.descripcion ||
      null;

    return {
      marcaDescripcion,
      modeloDescripcion,
      submodeloDescripcion
    };
  }, [data, marcas, modelos, submodelos]);

  useEffect(() => {
    const descriptions = getDescriptions();

    if (
      descriptions.marcaDescripcion !== data.marcaDescripcion ||
      descriptions.modeloDescripcion !== data.modeloDescripcion ||
      descriptions.submodeloDescripcion !== data.submodeloDescripcion
    ) {
      updateData({ ...data, ...descriptions });
    }
  }, [getDescriptions, data, updateData]);

  useEffect(() => {
    getMarcas();
  }, [getMarcas]);

  return (
    <Form
      name="vehiculo"
      form={form}
      scrollToFirstError
      initialValues={data}
      layout="vertical"
      noValidate
      onValuesChange={(changedValues, allValues) => updateData(allValues)}
    >
      <Row
        gutter={[16, 0]}
        style={{
          marginTop: 'auto',
          marginBottom: 'auto',
          marginLeft: 'auto',
          marginRight: 'auto',
          textAlign: 'start'
        }}
      >
        <Col xs={24} md={12}>
          <Form.Item label="Marca" name="marca" rules={[{ required: true }]}>
            <Select
              disabled
              showSearch
              filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
              style={{ width: '100%' }}
              optionFilterProp="children"
              placeholder="Elegir marca"
            >
              {marcas.map((item) => (
                <Option key={item.id} value={item.id}>
                  {item.descripcion}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
        <Col xs={24} md={12}>
          <Form.Item label="Modelo" name="modelo" rules={[{ required: true }]}>
            <Select
              disabled
              showSearch
              filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
              style={{ width: '100%' }}
              placeholder="Elegir modelo"
            >
              {modelos.map((item) => (
                <Option key={item.id} value={item.id}>
                  {item.descripcion}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
        <Col xs={24} md={12}>
          <Form.Item label="Año" name="anio" rules={[{ required: true }]}>
            <Select
              disabled
              showSearch
              filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
              style={{ width: '100%' }}
              placeholder="Elegir año"
            >
              {anios.map((item) => (
                <Option key={item.descripcion} value={item.descripcion}>
                  {item.descripcion}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
        <Col xs={24} md={12}>
          <Form.Item
            label="Submodelo"
            name="submodelo"
            dependencies={['anio']}
            rules={[{ required: true }]}
          >
            <Select
              disabled
              showSearch
              filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
              style={{ width: '100%' }}
              placeholder="Elegir submodelo"
            >
              {submodelos.map((item) => (
                <Option key={item.id} value={item.id}>
                  {item.descripcion}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
        <Col xs={24} md={12}>
          <Form.Item
            label="Chassis"
            name="chassis"
            rules={[{ required: true }]}
          >
            <Input placeholder="Ingrese un valor" />
          </Form.Item>
        </Col>

        <Col xs={24} md={12}>
          <Form.Item
            label="Chapa"
            name="chapa"
            rules={[
              { required: true },
              {
                min: 6,
                message: 'La longitud mínima es de 6 caracteres'
              }
            ]}
          >
            <Input placeholder="Ingrese un valor" maxLength={8} />
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
};

export default VehiculoCartaVerdeForm;
